import * as ko from "knockout";
import { BaseService } from "./_baseService";
import { portalHttpService } from "./httpService";

class CommonsService extends BaseService {
  constructor() {
    super("commons");
  }

  getCountries = () => {
    return portalHttpService.get<{ country: string; description: string }[]>(`${this.baseApiUrl()}/Countries`);
  };

  getStateProvinces = (countryCode: string) => {
    return portalHttpService.get<{ state_prov: string; description: string }[]>(
      `${this.baseApiUrl()}/StateProvinces?country=${countryCode}`,
    );
  };
}

export const commonsService = new CommonsService();
